// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-table {
  padding-bottom: 2rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.preview-table__upper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}
.preview-table__upper__controls {
  display: flex;
  flex-direction: row;
  justify-content: end;
  height: fit-content;
  gap: 0.5rem;
}
.preview-table__upper__controls__add-button {
  width: fit-content;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.preview-table__upper__controls__filter-button {
  width: fit-content;
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.preview-table__table {
  height: 90%;
}
.preview-table__table__header {
  text-transform: uppercase;
  position: sticky;
  padding: 10px 1rem;
  display: grid;
  grid-template-columns: 5% 15% 15% 15% 15% 15% 15%;
  place-items: center;
  background-color: #F9FAFB;
  border-radius: 7px;
  height: 15%;
  font-size: 0.85rem;
}
.preview-table__table__header__cell.sortable-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}
.preview-table__table__header__cell.sortable-header:hover {
  color: #4F4BFF;
}
.preview-table__table__header__cell.sortable-header:hover:not(:has(.pi))::after {
  content: "\\e930";
  font-family: "primeicons";
  font-size: 0.75rem;
  opacity: 0.5;
  margin-left: 0.5rem;
}
.preview-table__table__header__cell.sortable-header .pi {
  font-size: 0.75rem;
}
.preview-table__table__body {
  height: 44vh;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
}
.preview-table__table__footer {
  margin-top: 1vh;
  width: 100%;
  display: flex;
  justify-content: end;
}
.preview-table__table__footer__summary-row {
  width: 80%;
  text-transform: uppercase;
  position: sticky;
  padding: 10px 1rem;
  display: grid;
  grid-template-columns: 18% 19% 19% 19% 19%;
  place-items: center;
  background-color: #F3F2FF;
  border-radius: 7px;
  height: 15%;
  font-size: 0.85rem;
}
.preview-table__filter-container {
  position: relative;
}
.preview-table__filters-popup {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
}
.preview-table__filters-popup__item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
}
.preview-table__filters-popup__item label {
  cursor: pointer;
  margin-left: 0.5rem;
}
.preview-table__filters-popup__item:hover {
  background: #f5f5f5;
}
.preview-table .filters-active {
  background-color: #4F4BFF;
  color: white;
}
.preview-table .filters-active:hover {
  background-color: #3f3ccc;
}

.p-checkbox.p-highlight .p-checkbox-box {
  background-color: #4F4BFF;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/preview-table/preview-table.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAGZ;AAFY;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAIhB;AADY;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAGhB;AACI;EACI,WAAA;AACR;AAAQ;EACI,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iDAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAEZ;AAAY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAEhB;AAAgB;EACI,cAAA;AAEpB;AACwB;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAC5B;AAIgB;EACI,kBAAA;AAFpB;AAMQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAJZ;AAMQ;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;AAJZ;AAKW;EACK,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAHhB;AAQI;EACI,kBAAA;AANR;AASI;EACI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAPR;AASQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAPZ;AASY;EACI,eAAA;EACA,mBAAA;AAPhB;AAUY;EACI,mBAAA;AARhB;AAaI;EACI,yBAAA;EACA,YAAA;AAXR;AAaQ;EACI,yBAAA;AAXZ;;AAgBA;EACI,yBAAA;AAbJ","sourcesContent":[".preview-table{\n    padding-bottom: 2rem;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    &__upper{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: end;\n        &__controls{\n            display: flex;\n            flex-direction: row;\n            justify-content: end;\n            height: fit-content;\n            gap: 0.5rem;\n            &__add-button{\n                width: fit-content;\n                height: 40px;\n                background-color:#4F4BFF;\n                color: white;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n\n            &__filter-button{\n                width: fit-content;\n                height: 40px;\n                background-color:transparent;\n                color: black;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n        }\n    }\n    &__table{\n        height: 90%;\n        &__header{\n            text-transform: uppercase;\n            position: sticky;\n            padding: 10px 1rem;\n            display: grid;\n            grid-template-columns: 5% 15% 15% 15% 15% 15% 15%;\n            place-items: center;\n            background-color: #F9FAFB;\n            border-radius: 7px;\n            height: 15%;\n            font-size: 0.85rem;\n\n            &__cell.sortable-header {\n                display: flex;\n                align-items: center;\n                gap: 0.5rem;\n                cursor: pointer;\n                user-select: none;\n                position: relative;\n                \n                &:hover {\n                    color: #4F4BFF;\n\n                    &:not(:has(.pi)) {\n                        &::after {\n                            content: '\\e930';\n                            font-family: 'primeicons';\n                            font-size: 0.75rem;\n                            opacity: 0.5;\n                            margin-left: 0.5rem;\n                        }\n                    }\n                }\n\n                .pi {\n                    font-size: 0.75rem;\n                }\n            }\n        }\n        &__body{\n            height: 44vh;\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            overflow: auto;\n        }\n        &__footer{\n            margin-top: 1vh;\n            width: 100%;\n            display: flex;\n            justify-content: end;\n           &__summary-row{\n                width: 80%;\n                text-transform: uppercase;\n                position: sticky;\n                padding: 10px 1rem;\n                display: grid;\n                grid-template-columns: 18% 19% 19% 19% 19%;\n                place-items: center;\n                background-color: #F3F2FF;\n                border-radius: 7px;\n                height: 15%;\n                font-size: 0.85rem;\n           }\n        }\n    }\n    \n    &__filter-container {\n        position: relative;\n    }\n\n    &__filters-popup {\n        position: absolute;\n        top: calc(100% + 5px);\n        right: 0;\n        background: white;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n        padding: 1rem;\n        box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n        z-index: 1000;\n        min-width: 200px;\n        max-height: 300px;\n        overflow-y: auto;\n\n        &__item {\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n            padding: 0.5rem;\n            cursor: pointer;\n\n            label {\n                cursor: pointer;\n                margin-left: 0.5rem;\n            }\n\n            &:hover {\n                background: #f5f5f5;\n            }\n        }\n    }\n\n    .filters-active {\n        background-color: #4F4BFF;\n        color: white;\n        \n        &:hover {\n            background-color: #3f3ccc;\n        }\n    }\n}\n\n.p-checkbox.p-highlight .p-checkbox-box{\n    background-color: #4F4BFF ;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
